import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';
import fetchAddress from './fetchAddress';

const fetchFulfilmentLocation = async fulfilmentLocationId => {
  try {
    const locationResponse = await fulfilmentApi.getFulfilmentLocation(fulfilmentLocationId);
    const { data: locationData = {} } = locationResponse;

    if (locationData.address_id) {
      const address = await fetchAddress(locationData.address_id).catch(() => {});
      return { location_data: { ...locationData }, ...address };
    }

    return { location_data: { ...locationData } };
  } catch (error) {
    return Promise.reject(error);
  }
};

export default fetchFulfilmentLocation;
